// Central registry of test ids for the Production Dashboard.
export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submitBtn: "auth-submit-btn",
  toggleMode: "auth-toggle-mode",
  logoutBtn: "auth-logout-btn",
  langToggle: "lang-toggle",
  errorMessage: "auth-error-message",
};

export const DASHBOARD = {
  root: "dashboard-root",
  tabOrders: "tab-orders",
  tabTasks: "tab-tasks",
  tabEmployees: "tab-employees",
  newOrderBtn: "new-order-btn",
  newTaskBtn: "new-task-btn",
  newEmployeeBtn: "new-employee-btn",
  ordersList: "orders-list",
  tasksList: "tasks-list",
  employeesList: "employees-list",
  orderCard: (id) => `order-card-${id}`,
  taskCard: (id) => `task-card-${id}`,
  employeeRow: (id) => `employee-row-${id}`,
  countdownBadge: (id) => `countdown-badge-${id}`,
  markCompleteBtn: (id) => `mark-complete-btn-${id}`,
  taskFilterEmployee: "task-filter-employee",
  taskFilterDue: "task-filter-due",
  taskFilterStatus: "task-filter-status",
  kpiOverdue: "kpi-overdue",
  kpiToday: "kpi-today",
  kpiUpcoming: "kpi-upcoming",
  kpiTotal: "kpi-total",
  kpiOpenOrders: "kpi-open-orders",
  kpiDeliveriesToday: "kpi-deliveries-today",
  kpiDeliveriesWeek: "kpi-deliveries-week",
  kpiTotalPending: "kpi-total-pending",
  kpiTotalCollected: "kpi-total-collected",
  brandLogo: "brand-logo",
  orderPdfBtn: (id) => `order-pdf-${id}`,
  // Phase 3
  tabDashboard: "tab-dashboard",
  tabCalendar: "tab-calendar",
  tabOrderHistory: "tab-order-history",
  orderViewBtn: (id) => `order-view-${id}`,
  orderDetailsModal: "order-details-modal",
  orderHistorySearch: "order-history-search",
  ordersSearchInput: "orders-search-input",
  tasksSearchInput: "tasks-search-input",
  orderHistoryList: "order-history-list",
  orderHistoryRow: (id) => `order-history-row-${id}`,
  calendarView: "calendar-view",
  calendarPrev: "calendar-prev",
  calendarNext: "calendar-next",
  calendarToday: "calendar-today",
  calendarDay: (iso) => `calendar-day-${iso}`,
  calendarTask: (id) => `calendar-task-${id}`,
  // Task details from calendar
  taskDetailsModal: "task-details-modal",
  taskDetailsOpenOrder: "task-details-open-order",
  taskDetailsComplete: (id) => `task-details-complete-${id}`,
  // Invoice PDF attachment
  invoicePdfInput: "invoice-pdf-input",
  invoicePdfImportBtn: "invoice-pdf-import-btn",
  invoicePdfViewBtn: "invoice-pdf-view-btn",
  invoicePdfRemoveBtn: "invoice-pdf-remove-btn",
  // Task priority
  taskPrioritySelect: "task-priority-select",
  taskPriorityBadge: (id) => `task-priority-badge-${id}`,
  // Settings (Sprint 1 — Financial Configuration)
  tabSettings: "tab-settings",
  settingsHub: "settings-hub",
  settingsCardFinancial: "settings-card-financial",
  financialConfigRoot: "financial-config-root",
  financialBackBtn: "financial-back-btn",
  tabCategories: "tab-categories",
  tabFinancialProducts: "tab-financial-products",
  // Categories
  categoryNewBtn: "category-new-btn",
  categoriesList: "categories-list",
  categoryRow: (id) => `category-row-${id}`,
  categoryEditBtn: (id) => `category-edit-${id}`,
  categoryToggleBtn: (id) => `category-toggle-${id}`,
  categoryFormName: "category-form-name",
  categoryFormSubmit: "category-form-submit",
  categoryFormCancel: "category-form-cancel",
  categoryFilterStatus: "category-filter-status",
  // Financial Products
  financialProductNewBtn: "financial-product-new-btn",
  financialProductsList: "financial-products-list",
  financialProductRow: (id) => `financial-product-row-${id}`,
  financialProductEditBtn: (id) => `financial-product-edit-${id}`,
  financialProductToggleBtn: (id) => `financial-product-toggle-${id}`,
  financialProductFormName: "financial-product-form-name",
  financialProductFormCategory: "financial-product-form-category",
  financialProductFormCost: "financial-product-form-cost",
  financialProductFormDescription: "financial-product-form-description",
  financialProductFormSubmit: "financial-product-form-submit",
  financialProductFormCancel: "financial-product-form-cancel",
  financialProductFilterCategory: "financial-product-filter-category",
  financialProductFilterStatus: "financial-product-filter-status",
  // Product Types (Sprint 2)
  settingsCardProductTypes: "settings-card-product-types",
  // V2 Master Catalog Hub (Sprint 5)
  settingsCardCatalogs: "settings-card-catalogs",
  catalogsHub: "catalogs-hub",
  productTypesRoot: "product-types-root",
  productTypesBackBtn: "product-types-back-btn",
  productTypesList: "product-types-list",
  productTypeNewBtn: "product-type-new-btn",
  productTypeRow: (id) => `product-type-row-${id}`,
  productTypeEditBtn: (id) => `product-type-edit-${id}`,
  productTypeToggleBtn: (id) => `product-type-toggle-${id}`,
  productTypeFormName: "product-type-form-name",
  productTypeFormDescription: "product-type-form-description",
  productTypeFormSubmit: "product-type-form-submit",
  productTypeFormCancel: "product-type-form-cancel",
  productTypeFilterStatus: "product-type-filter-status",
  // Sprint 3 — Smart field_schema editor (in ProductType modal)
  productTypeSchemaAddBtn: "product-type-schema-add-btn",
  productTypeSchemaRow: (i) => `product-type-schema-row-${i}`,
  productTypeSchemaKey: (i) => `product-type-schema-key-${i}`,
  productTypeSchemaLabel: (i) => `product-type-schema-label-${i}`,
  productTypeSchemaType: (i) => `product-type-schema-type-${i}`,
  productTypeSchemaUnit: (i) => `product-type-schema-unit-${i}`,
  productTypeSchemaOptions: (i) => `product-type-schema-options-${i}`,
  productTypeSchemaRequired: (i) => `product-type-schema-required-${i}`,
  productTypeSchemaRemove: (i) => `product-type-schema-remove-${i}`,
  // Sprint 3 — Type selector + dynamic custom fields in FinancialProduct modal
  financialProductFormType: "financial-product-form-type",
  financialProductFormCustomField: (key) => `financial-product-cf-${key}`,
  // Sprint 4 — catalog pricing fields on FinancialProduct
  financialProductFormSku: "financial-product-form-sku",
  financialProductFormSuggestedPrice: "financial-product-form-suggested-price",
  financialProductFormSuggestedMargin: "financial-product-form-suggested-margin",
  // Sprint 4 — Order item ↔ catalog product linkage
  orderItemProductSelect: (idx) => `form-order-item-product-${idx}`,
  orderItemUnitPrice: (idx) => `form-order-item-unit-price-${idx}`,
  orderItemUnitCost: (idx) => `form-order-item-unit-cost-${idx}`,
  orderItemSubtotal: (idx) => `form-order-item-subtotal-${idx}`,
  orderItemCostTotal: (idx) => `form-order-item-cost-total-${idx}`,
  orderItemProfit: (idx) => `form-order-item-profit-${idx}`,
  orderItemCustomField: (idx, key) => `form-order-item-cf-${idx}-${key}`,
  orderTotalsSubtotal: "form-order-totals-subtotal",
  orderTotalsCost: "form-order-totals-cost",
  orderTotalsProfit: "form-order-totals-profit",
  orderTotalsMargin: "form-order-totals-margin",
  // Sprint 5.2 — V2 Master Catalog dropdowns on FinancialProduct form
  financialProductFormItemType: "financial-product-form-item-type",
  financialProductFormBrand: "financial-product-form-brand",
  financialProductFormSupplier: "financial-product-form-supplier",
  financialProductFormColor: "financial-product-form-color",
  financialProductFormSize: "financial-product-form-size",
  financialProductFormUom: "financial-product-form-uom",
  financialProductFormModel: "financial-product-form-model",
  financialProductFormRequiresDimensions: "financial-product-form-requires-dimensions",
  // Sprint 5.3 — Order item structured production fields
  orderItemDecorationMethod: (idx) => `form-order-item-decoration-${idx}`,
  orderItemLogoLocation: (idx) => `form-order-item-logo-location-${idx}`,
  orderItemColorsUsed: (idx) => `form-order-item-colors-used-${idx}`,
  orderItemArtworkUrl: (idx) => `form-order-item-artwork-${idx}`,
  orderItemCustomerNotes: (idx) => `form-order-item-customer-notes-${idx}`,
  orderItemWidth: (idx) => `form-order-item-width-${idx}`,
  orderItemHeight: (idx) => `form-order-item-height-${idx}`,
  orderItemThickness: (idx) => `form-order-item-thickness-${idx}`,
  orderItemAreaSqft: (idx) => `form-order-item-area-sqft-${idx}`,
  // Sprint 5.4 — CSV importer for the Master Catalog
  productsImportButton: "financial-products-import-btn",
  productsImportModal: "financial-products-import-modal",
  productsImportTemplateBtn: "financial-products-import-template-btn",
  productsImportFileInput: "financial-products-import-file",
  productsImportMatchBy: "financial-products-import-match-by",
  productsImportPreviewBtn: "financial-products-import-preview-btn",
  productsImportExecuteBtn: "financial-products-import-execute-btn",
  productsImportCancelBtn: "financial-products-import-cancel-btn",
  productsImportSummary: "financial-products-import-summary",
  productsImportRow: (rowNumber) => `financial-products-import-row-${rowNumber}`,
  // Sprint 5.5 — search, filters, status, where-used
  productsSearchInput: "financial-products-search-input",
  productsFilterBrand: "financial-products-filter-brand",
  productsFilterColor: "financial-products-filter-color",
  productsFilterSize: "financial-products-filter-size",
  productsFilterSupplier: "financial-products-filter-supplier",
  productsFilterStatus: "financial-products-filter-status",
  productsFiltersReset: "financial-products-filters-reset",
  productStatusSelect: (id) => `financial-product-status-select-${id}`,
  productWhereUsedBtn: (id) => `financial-product-where-used-${id}`,
  productWhereUsedModal: "financial-product-where-used-modal",
  productWhereUsedCount: "financial-product-where-used-count",
  productWhereUsedClose: "financial-product-where-used-close",
  // Sprint O1 — Production board (item-centric)
  tabProduction: "tab-production",
  productionBoard: "production-board",
  productionFilterBlocker: "production-filter-blocker",
  productionFilterStatus: "production-filter-status",
  productionFilterEmployee: "production-filter-employee",
  productionFilterMethod: "production-filter-method",
  productionFiltersReset: "production-filters-reset",
  productionCard: (orderId, itemId) => `production-card-${orderId}-${itemId}`,
  productionStatusSelect: (itemId) => `production-status-select-${itemId}`,
  productionAssigneeSelect: (itemId) => `production-assignee-select-${itemId}`,
  productionBlockerArt: (itemId) => `production-blocker-art-${itemId}`,
  productionBlockerPayment: (itemId) => `production-blocker-payment-${itemId}`,
  productionBlockerMaterial: (itemId) => `production-blocker-material-${itemId}`,
  productionBlockerApproval: (itemId) => `production-blocker-approval-${itemId}`,
  productionOpenOrderBtn: (orderId) => `production-open-order-${orderId}`,
  // Sprint O2 — Quick-open command palette
  quickOpenTrigger: "quick-open-trigger",
  quickOpenModal: "quick-open-modal",
  quickOpenInput: "quick-open-input",
  quickOpenResult: (i) => `quick-open-result-${i}`,
  duplicateOrderBtn: (orderId) => `order-duplicate-${orderId}`,
  // Sprint O3 — View mode toggle on production board
  productionViewMode: "production-view-mode",
  productionGroupHeader: (groupId) => `production-group-${groupId}`,
  // Sprint O4 — Delivery modal
  openDeliverModalBtn: (orderId) => `order-deliver-btn-${orderId}`,
  deliverOrderModal: "deliver-order-modal",
  deliverOrderClose: "deliver-order-close",
  deliverOrderNote: "deliver-order-note",
  deliverOrderToggleFinalPayment: "deliver-order-toggle-final-payment",
  deliverOrderPaymentAmount: "deliver-order-payment-amount",
  deliverOrderPaymentMethod: "deliver-order-payment-method",
  deliverOrderPaymentNote: "deliver-order-payment-note",
  deliverOrderConfirm: "deliver-order-confirm",
  // Sprint O4 — Payments tab inside OrderDetailsModal
  paymentsAddBtn: "payments-add-btn",
  paymentsAmount: "payments-amount",
  paymentsMethod: "payments-method",
  paymentsNote: "payments-note",
  paymentsSubmit: "payments-submit",
  paymentsRow: (id) => `payment-row-${id}`,
  paymentsDelete: (id) => `payment-delete-${id}`,
  // Sprint O5 — Auto-tasks + bulk assign + my-day
  autoTasksBtn: (itemId) => `auto-tasks-btn-${itemId}`,
  tasksBulkSelect: (taskId) => `tasks-bulk-select-${taskId}`,
  tasksBulkAssignTrigger: "tasks-bulk-assign-trigger",
  tasksBulkAssignSelect: "tasks-bulk-assign-select",
  tasksBulkAssignSubmit: "tasks-bulk-assign-submit",
  myDayBtn: "my-day-btn",
  myDayPanel: "my-day-panel",
  // Smart Products (Catálogo inteligente — V2 aditivo)
  settingsCardSmartProducts: "settings-card-smart-products",
  smartProductsRoot: "smart-products-root",
  smartProductsBackBtn: "smart-products-back-btn",
  smartProductsList: "smart-products-list",
  smartProductsNewBtn: "smart-products-new-btn",
  smartProductsEmpty: "smart-products-empty",
  smartProductsFilterStatus: "smart-products-filter-status",
  smartProductsSearch: "smart-products-search",
  smartProductRow: (id) => `smart-product-row-${id}`,
  smartProductEditBtn: (id) => `smart-product-edit-${id}`,
  smartProductToggleBtn: (id) => `smart-product-toggle-${id}`,
  smartProductFormModal: "smart-product-form-modal",
  smartProductFormName: "smart-product-form-name",
  smartProductFormCode: "smart-product-form-code",
  smartProductFormCategory: "smart-product-form-category",
  smartProductFormItemType: "smart-product-form-item-type",
  smartProductFormUom: "smart-product-form-uom",
  smartProductFormBrand: "smart-product-form-brand",
  smartProductFormSupplier: "smart-product-form-supplier",
  smartProductFormActive: "smart-product-form-active",
  smartProductFormSubmit: "smart-product-form-submit",
  smartProductFormCancel: "smart-product-form-cancel",
  smartProductFieldToggle: (key) => `smart-product-field-${key}`,
  // Product Taxonomy (Categorías de Productos + Subcategorías)
  tabProductCategories: "tab-product-categories",
  tabProductSubcategories: "tab-product-subcategories",
  productCategoriesPrefix: "product-categories",
  productSubcategoriesPrefix: "product-subcategories",
  // Smart Products — image upload + production time
  smartProductFormSubcategory: "smart-product-form-subcategory",
  smartProductFormImageInput: "smart-product-form-image-input",
  smartProductFormImageRemove: "smart-product-form-image-remove",
  smartProductFormImagePreview: "smart-product-form-image-preview",
  smartProductFormProdTimeValue: "smart-product-form-prod-time-value",
  smartProductFormProdTimeUnit: "smart-product-form-prod-time-unit",
  smartProductFormDefaultModel: "smart-product-form-default-model",
  smartProductFormDescription: "smart-product-form-description",
  // Orders → Smart Product integration
  orderItemSmartProductPicker: (idx) => `order-item-${idx}-smart-product`,
  orderItemDynamicField: (idx, key) => `order-item-${idx}-field-${key}`,
  orderItemHeritageBadge: (idx, key) => `order-item-${idx}-heritage-${key}`,
  // Roles & Permissions v2 (RBAC engine)
  settingsCardRoles: "settings-card-roles",
  rolesRoot: "roles-root",
  rolesBackBtn: "roles-back-btn",
  rolesList: "roles-list",
  rolesNewBtn: "roles-new-btn",
  roleRow: (id) => `role-row-${id}`,
  roleEditBtn: (id) => `role-edit-${id}`,
  roleDuplicateBtn: (id) => `role-duplicate-${id}`,
  roleDeleteBtn: (id) => `role-delete-${id}`,
  roleFormModal: "role-form-modal",
  roleFormName: "role-form-name",
  roleFormDescription: "role-form-description",
  roleFormSubmit: "role-form-submit",
  roleFormCancel: "role-form-cancel",
  rolePermCheckbox: (module, action) => `role-perm-${module}-${action}`,
  rolePermModuleAll: (module) => `role-perm-module-all-${module}`,
  // Employees — assign roles + overrides
  employeeRolesChip: (roleId) => `emp-role-chip-${roleId}`,
  employeeOverrideGrant: (module, action) => `emp-override-grant-${module}-${action}`,
  employeeOverrideRevoke: (module, action) => `emp-override-revoke-${module}-${action}`,
  employeeOverridesToggle: "emp-overrides-toggle",
  // Pricing Engine Admin (2026-02-15)
  settingsCardPricing: "settings-card-pricing",
  pricingEngineRoot: "pricing-engine-root",
  pricingBackBtn: "pricing-back-btn",
  pricingRulesList: "pricing-rules-list",
  pricingRuleRow: (id) => `pricing-rule-row-${id}`,
  pricingRuleNewBtn: "pricing-rule-new-btn",
  pricingRuleEditBtn: (id) => `pricing-rule-edit-${id}`,
  pricingRuleDeleteBtn: (id) => `pricing-rule-delete-${id}`,
  pricingRuleToggleBtn: (id) => `pricing-rule-toggle-${id}`,
  pricingRuleFormModal: "pricing-rule-form-modal",
  pricingRuleFormName: "pricing-rule-form-name",
  pricingRuleFormStrategy: "pricing-rule-form-strategy",
  pricingRuleFormMarkupPct: "pricing-rule-form-markup-pct",
  pricingRuleFormFixedPrice: "pricing-rule-form-fixed-price",
  pricingRuleFormFormula: "pricing-rule-form-formula",
  pricingRuleFormBreakRow: (i) => `pricing-rule-form-break-${i}`,
  pricingRuleFormBreakAdd: "pricing-rule-form-break-add",
  pricingRuleFormBreakRemove: (i) => `pricing-rule-form-break-remove-${i}`,
  pricingRuleFormMinProfit: "pricing-rule-form-min-profit",
  pricingRuleFormMaxDiscount: "pricing-rule-form-max-discount",
  pricingRuleFormPriority: "pricing-rule-form-priority",
  pricingRuleFormIsDefault: "pricing-rule-form-is-default",
  pricingRuleFormIsActive: "pricing-rule-form-is-active",
  pricingRuleFormNotes: "pricing-rule-form-notes",
  pricingRuleFormFilterConnector: "pricing-rule-form-filter-connector",
  pricingRuleFormFilterSourceType: "pricing-rule-form-filter-source-type",
  pricingRuleFormFilterBrand: "pricing-rule-form-filter-brand",
  pricingRuleFormFilterCategory: "pricing-rule-form-filter-category",
  pricingRuleFormFilterStyle: "pricing-rule-form-filter-style",
  pricingRuleFormFilterSku: "pricing-rule-form-filter-sku",
  pricingRuleFormFilterColor: "pricing-rule-form-filter-color",
  pricingRuleFormFilterSize: "pricing-rule-form-filter-size",
  pricingRuleFormFilterCustomerCategory: "pricing-rule-form-filter-customer-category",
  pricingRuleFormFilterMinQuantity: "pricing-rule-form-filter-min-quantity",
  pricingRuleFormSubmit: "pricing-rule-form-submit",
  pricingRuleFormCancel: "pricing-rule-form-cancel",
  // Live simulator (sticky side panel)
  pricingSimulator: "pricing-simulator",
  pricingSimBrand: "pricing-sim-brand",
  pricingSimCategory: "pricing-sim-category",
  pricingSimStyle: "pricing-sim-style",
  pricingSimSku: "pricing-sim-sku",
  pricingSimColor: "pricing-sim-color",
  pricingSimSize: "pricing-sim-size",
  pricingSimQuantity: "pricing-sim-quantity",
  pricingSimCost: "pricing-sim-cost",
  pricingSimConnector: "pricing-sim-connector",
  pricingSimSourceType: "pricing-sim-source-type",
  pricingSimCustomerCategory: "pricing-sim-customer-category",
  pricingSimResultUnitPrice: "pricing-sim-result-unit-price",
  pricingSimResultTotal: "pricing-sim-result-total",
  pricingSimResultMargin: "pricing-sim-result-margin",
  pricingSimResultRuleName: "pricing-sim-result-rule-name",
  pricingSimResultStrategy: "pricing-sim-result-strategy",
  pricingSimResultClamps: "pricing-sim-result-clamps",
  pricingSimResultFallback: "pricing-sim-result-fallback",
  pricingSimResetBtn: "pricing-sim-reset-btn",
};

export const FORM = {
  // Order
  orderCustomer: "form-order-customer",
  orderProduct: "form-order-product",
  orderDelivery: "form-order-delivery",
  orderNotes: "form-order-notes",
  orderStatus: "form-order-status",
  orderSubmit: "form-order-submit",
  orderCancel: "form-order-cancel",
  orderDelete: (id) => `order-delete-${id}`,
  orderEdit: (id) => `order-edit-${id}`,

  // Task
  taskName: "form-task-name",
  taskOrder: "form-task-order",
  taskEmployee: "form-task-employee",
  taskDue: "form-task-due",
  taskProduct: "form-task-product",
  taskStatus: "form-task-status",
  taskSubmit: "form-task-submit",
  taskCancel: "form-task-cancel",
  taskDelete: (id) => `task-delete-${id}`,
  taskEdit: (id) => `task-edit-${id}`,

  // Employee
  empName: "form-employee-name",
  empRole: "form-employee-role",
  empEmail: "form-employee-email",
  empSubmit: "form-employee-submit",
  empCancel: "form-employee-cancel",
  empDelete: (id) => `employee-delete-${id}`,
  empEdit: (id) => `employee-edit-${id}`,
};
